export default __webpack_public_path__ + "static/1900_1910-d757d8195fe60b3cf723a26e53a151d6.mp4";